function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray2(arr); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _excluded = ["className", "direction", "disabled", "dropdownProps", "inputClassName", "options", "placeholder", "value", "menuMaxHeight", "multi", "noResultsLabel", "onChange", "onCreate", "isValidNewOption", "filterOptions", "renderOption"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import equal from 'fast-deep-equal';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { findDOMNode } from 'react-dom';
import Badge from "../Badge/Badge";
import Button from "../Button/Button";
import Dropdown from "../Dropdown/Dropdown";
import DropdownItem from "../Dropdown/DropdownItem";
import DropdownMenu from "../Dropdown/DropdownMenu";
import DropdownToggle from "../Dropdown/DropdownToggle";
import Icon from "../Icon/Icon";
import Input from "../Input/Input";
import InputGroup from "../InputGroup/InputGroup";
var defaultProps = {
  noResultsLabel: 'No results found',
  onChange: function onChange() {},
  filterOptions: function filterOptions(o, v) {
    return o.filter(function (option) {
      return v ? option.label.toLowerCase().indexOf(v.toLowerCase()) > -1 : true;
    });
  },
  isValidNewOption: function isValidNewOption() {
    return true;
  },
  renderOption: function renderOption(option) {
    return option.label;
  }
};

function Combobox(_ref) {
  var _optionsProp$;

  var className = _ref.className,
      direction = _ref.direction,
      disabled = _ref.disabled,
      dropdownProps = _ref.dropdownProps,
      inputClassName = _ref.inputClassName,
      optionsProp = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      menuMaxHeight = _ref.menuMaxHeight,
      multi = _ref.multi,
      _ref$noResultsLabel = _ref.noResultsLabel,
      noResultsLabel = _ref$noResultsLabel === void 0 ? defaultProps.noResultsLabel : _ref$noResultsLabel,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      onCreate = _ref.onCreate,
      _ref$isValidNewOption = _ref.isValidNewOption,
      isValidNewOption = _ref$isValidNewOption === void 0 ? defaultProps.isValidNewOption : _ref$isValidNewOption,
      _ref$filterOptions = _ref.filterOptions,
      filterOptions = _ref$filterOptions === void 0 ? defaultProps.filterOptions : _ref$filterOptions,
      _ref$renderOption = _ref.renderOption,
      renderOption = _ref$renderOption === void 0 ? defaultProps.renderOption : _ref$renderOption,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      visibleOptions = _useState6[0],
      setVisibleOptions = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      focusedOptionIndex = _useState8[0],
      setFocusedOptionIndex = _useState8[1];

  var inputElement = useRef(null);
  var dropdownMenu = useRef(null);
  var focusedOption = useRef(null);
  var grouped = !!((_optionsProp$ = optionsProp[0]) !== null && _optionsProp$ !== void 0 && _optionsProp$.options);
  var options = useMemo(function () {
    if (optionsProp === [] || !optionsProp) {
      return [];
    }

    if (grouped) {
      return optionsProp.reduce(function (o, current) {
        return [].concat(_toConsumableArray(o), _toConsumableArray(current.options));
      }, []);
    }

    return optionsProp;
  }, [optionsProp, grouped]);
  var selected = useMemo(function () {
    return multi ? (value || []).map(function (v) {
      return options.find(function (option) {
        return equal(option.value, v);
      });
    }) : options.find(function (option) {
      return equal(option.value, value);
    });
  }, [value, options, multi]);
  var noMatches = visibleOptions.length === 0;

  var cursorAtStart = function cursorAtStart() {
    var _inputElement$current, _inputElement$current2;

    return (inputElement === null || inputElement === void 0 ? void 0 : (_inputElement$current = inputElement.current) === null || _inputElement$current === void 0 ? void 0 : _inputElement$current.selectionStart) === 0 && (inputElement === null || inputElement === void 0 ? void 0 : (_inputElement$current2 = inputElement.current) === null || _inputElement$current2 === void 0 ? void 0 : _inputElement$current2.selectionEnd) === 0;
  };

  useEffect(function () {
    if (visibleOptions.length > 0) {
      setFocusedOptionIndex(0);
    }
  }, [visibleOptions]);
  useEffect(function () {
    setInputValue(!multi && selected ? selected.label : '');
  }, [selected, open, multi]);
  useEffect(function () {
    if (!open && inputElement.current) {
      inputElement.current.blur();
    }

    if (open && !multi && selected && inputElement !== null && inputElement !== void 0 && inputElement.current) {
      window.setTimeout(function () {
        inputElement.current.setSelectionRange(0, 0);
      }, 1);
    }
  }, [open, multi, selected]);
  useEffect(function () {
    var selectableOptions = _toConsumableArray(options);

    if (multi && value) {
      selectableOptions = options.filter(function (o) {
        return value.indexOf(o.value) === -1;
      });
    }

    setVisibleOptions(filterOptions(selectableOptions, !multi && selected && inputValue === selected.label ? '' : inputValue));
  }, [inputValue, setVisibleOptions, filterOptions, options, multi, value, selected]);

  var scrollFocusedOptionIntoView = function scrollFocusedOptionIntoView() {
    if (dropdownMenu.current === null || focusedOption.current === null) {
      return;
    }
    /* eslint-disable react/no-find-dom-node */


    var focusedOptionNode = findDOMNode(focusedOption.current);
    var menuNode = findDOMNode(dropdownMenu.current);
    /* eslint-enable react/no-find-dom-node */

    if (focusedOptionNode === null || menuNode === null) {
      return;
    }

    var scrollTop = menuNode.scrollTop;
    var scrollBottom = scrollTop + menuNode.offsetHeight;
    var optionTop = focusedOptionNode.offsetTop;
    var optionBottom = optionTop + focusedOptionNode.offsetHeight;

    if (scrollTop > optionTop) {
      menuNode.scrollTop -= focusedOptionNode.offsetHeight;
    } else if (scrollBottom < optionBottom) {
      menuNode.scrollTop += focusedOptionNode.offsetHeight;
    }
  };

  useEffect(scrollFocusedOptionIntoView, [focusedOptionIndex]);

  var isOptionVisible = function isOptionVisible(option) {
    return visibleOptions.indexOf(option) > -1;
  };

  var isOptionSelected = function isOptionSelected(option) {
    if (multi) {
      return (value === null || value === void 0 ? void 0 : value.indexOf(option.value)) > -1;
    }

    return equal(value, option.value);
  };

  var selectOption = function selectOption(optionValue) {
    if (multi) {
      _onChange([].concat(_toConsumableArray(value || []), [optionValue]));

      return;
    }

    _onChange(optionValue);

    setOpen(false);
  };

  var showSelectedPreview = function showSelectedPreview() {
    setInputValue("".concat(selected.label, " "));
    window.setTimeout(function () {
      inputElement.current.setSelectionRange(0, 0);
    }, 1);
  };

  var clearSelectedPreview = function clearSelectedPreview() {
    if (!multi && selected && selected.label === inputValue) {
      if (cursorAtStart()) {
        setInputValue('');
      }
    }
  };

  var removeOption = function removeOption(option) {
    var i = value.indexOf(option.value);

    if (i > -1) {
      var newValue = _toConsumableArray(value);

      newValue.splice(i, 1);

      _onChange(newValue);
    }
  };

  var createOption = function createOption() {
    if (!onCreate) {
      return;
    }

    var optionValue = onCreate(inputValue);

    if (optionValue) {
      selectOption(optionValue);
    }
  };

  var handleOptionsKeyboardNav = function handleOptionsKeyboardNav(e) {
    var input = inputElement === null || inputElement === void 0 ? void 0 : inputElement.current;
    var allSelected = (input === null || input === void 0 ? void 0 : input.selectionStart) === 0 && input.selectionEnd === input.value.length;
    var isDisplayingSelected = !multi && selected && inputValue === selected.label;
    var key = e.key;

    if (!open && key === 'ArrowDown') {
      setOpen(true);
    } else if (key === 'Enter') {
      if (noMatches) {
        createOption();
        return;
      }

      selectOption(visibleOptions[focusedOptionIndex].value);
      e.preventDefault();
    } else if (key === 'ArrowDown' && focusedOptionIndex < visibleOptions.length - 1) {
      setFocusedOptionIndex(focusedOptionIndex + 1);
    } else if (key === 'ArrowUp' && focusedOptionIndex > 0) {
      setFocusedOptionIndex(focusedOptionIndex - 1);
    } else if (selected && key === 'Backspace' && (cursorAtStart() || allSelected && isDisplayingSelected)) {
      if (multi) {
        var newValue = _toConsumableArray(value);

        newValue.pop();

        _onChange(newValue);

        return;
      }

      _onChange(undefined);
    } else if (!multi && selected && key === 'Backspace' && ((input === null || input === void 0 ? void 0 : input.selectionStart) === 1 && (input === null || input === void 0 ? void 0 : input.selectionEnd) === 1 || allSelected && !isDisplayingSelected)) {
      showSelectedPreview();
    }
  };

  var renderOptions = function renderOptions(opts) {
    return opts.map(function (option) {
      var visibleIndex = visibleOptions.indexOf(option);
      var key = JSON.stringify(option.value);
      return /*#__PURE__*/React.createElement(DropdownItem, {
        disabled: option.disabled,
        className: "".concat(isOptionVisible(option) ? '' : 'visually-hidden'),
        key: key,
        id: "option-".concat(key),
        active: focusedOptionIndex === visibleIndex,
        onMouseEnter: function onMouseEnter(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          setFocusedOptionIndex(visibleIndex);
        },
        onMouseDown: function onMouseDown(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          selectOption(option.value);
        },
        ref: visibleIndex === focusedOptionIndex ? focusedOption : null,
        role: "option",
        "aria-selected": isOptionSelected(option)
      }, renderOption(option));
    });
  };

  var renderGroupedOptions = function renderGroupedOptions(groups) {
    return groups.map(function (group, i) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownItem, {
        header: true
      }, group.label), renderOptions(group.options), i !== groups.length - 1 && /*#__PURE__*/React.createElement(DropdownItem, {
        divider: true
      }));
    });
  };

  var renderNoOptions = function renderNoOptions() {
    if (onCreate) {
      return /*#__PURE__*/React.createElement(DropdownItem, {
        active: noMatches,
        "data-testid": "create-new-option",
        disabled: !isValidNewOption(inputValue),
        onMouseDown: function onMouseDown(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          createOption();
        }
      }, "Create \"".concat(inputValue, "\""));
    }

    return /*#__PURE__*/React.createElement(DropdownItem, {
      disabled: true
    }, noResultsLabel);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, multi && selected.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap mb-2"
  }, selected.map(function (o) {
    var key = JSON.stringify(o.value);
    return /*#__PURE__*/React.createElement(Button, {
      key: key,
      color: "",
      className: "btn-sm p-0 me-1",
      onClick: function onClick() {
        return removeOption(o);
      },
      "aria-label": "Remove option: ".concat(key)
    }, /*#__PURE__*/React.createElement(Badge, {
      style: {
        textTransform: 'none'
      },
      className: "p-2"
    }, o.label, " ", /*#__PURE__*/React.createElement(Icon, {
      name: "close"
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    key: "clear-all",
    color: "",
    className: "btn-sm p-0 me-1 text-secondary",
    onClick: function onClick() {
      return _onChange([]);
    },
    "aria-label": "Remove all selected options"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    "data-testid": "combobox-dropdown",
    direction: direction,
    isOpen: !disabled && open,
    toggle: function toggle() {},
    onBlur: function onBlur(_ref2) {
      var blurred = _ref2.currentTarget,
          focused = _ref2.relatedTarget;

      if (focused instanceof Node && blurred.contains(focused)) {
        return;
      }

      setOpen(false);
    }
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    tag: "div",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: className
  }, /*#__PURE__*/React.createElement(Input, _extends({
    innerRef: inputElement,
    "data-testid": "combobox-input",
    disabled: disabled,
    className: inputClassName,
    placeholder: selected ? undefined : placeholder,
    onFocus: function onFocus(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      setOpen(true);
    },
    onChange: function onChange(e) {
      e.preventDefault();
      e.stopPropagation();
      setInputValue(e.target.value);

      if (!multi && selected && cursorAtStart() && e.target.value === '') {
        _onChange(undefined);
      }
    },
    onMouseDown: function onMouseDown(e) {
      if (!multi && selected) {
        inputElement.current.setSelectionRange(0, 0);

        if (selected.label === inputValue) {
          e.preventDefault();
        }
      } // @ts-ignore


      e.target.focus();
    },
    onKeyDown: handleOptionsKeyboardNav,
    onKeyPress: clearSelectedPreview,
    onPaste: clearSelectedPreview,
    type: props.type || 'search',
    value: inputValue,
    "aria-label": "Filter options"
  }, props)), /*#__PURE__*/React.createElement(Button, {
    className: "px-2",
    "data-testid": "combobox-caret",
    disabled: disabled,
    active: open,
    onMouseDown: function onMouseDown(ev) {
      ev.stopPropagation();
      setOpen(!open);
    },
    type: "button",
    "aria-label": "Toggle options menu"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: open ? 'caret-up' : 'caret-down',
    fixedWidth: true
  })))), /*#__PURE__*/React.createElement(DropdownMenu, _extends({
    "data-testid": "combobox-menu",
    className: "p-0 w-100",
    style: {
      maxHeight: menuMaxHeight || '12rem',
      overflowY: 'auto'
    }
  }, dropdownProps, {
    ref: dropdownMenu,
    role: "listbox",
    "aria-activedescendant": visibleOptions[focusedOptionIndex] && "option-".concat(JSON.stringify(visibleOptions[focusedOptionIndex].value)),
    "aria-multiselectable": multi
  }), grouped ? renderGroupedOptions(optionsProp) : renderOptions(options), noMatches && renderNoOptions())));
}

Combobox.displayName = 'Combobox';
Combobox.defaultProps = defaultProps;
export default Combobox;